import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import { v1 as uuid } from 'uuid';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { makeStyles } from '@mui/styles';
import Rows from './Rows';
import Header from './Header';

const useStyles = makeStyles(theme => ({
  accordion: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    paddingBottom: theme.spacing(1),

    '&:before': {
      display: 'none'
    }
  },
  accordionSummary: {
    pointerEvents: ({ disable }) => (!disable ? 'auto' : 'none'),
    backgroundColor: ({ severity }) => theme.palette.alerts[severity].background,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: 0
    }
  },
  expandIcon: {
    visibility: ({ disable }) => (!disable ? 'visible' : 'hidden'),
    color: ({ severity }) => theme.palette.alerts[severity].color,

    [theme.breakpoints.down('sm')]: {
      marginRight: 0
    }
  },
  content: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    padding: `${theme.spacing(1)} 0`,

    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      marginBottom: 0
    },

    '&$expanded': {
      margin: 0
    }
  },
  expanded: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),

    '&$expanded': {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
      minHeight: 'auto'
    }
  },
  accordionDetails: {
    flexDirection: 'column',
    padding: `${theme.spacing(1)} 0`,
    gap: theme.spacing(1)
  }
}));

const SeverityGroup = ({ severity, rowsData } = {}) => {
  const countRows = rowsData.filter(row => row[1]).length;
  const classes = useStyles({
    severity,
    disable: typeof rowsData === 'number'
  });
  if (countRows === 0) {
    return <></>;
  }

  return (
    <Accordion
      key={uuid()}
      expanded
      classes={{
        root: classes.accordion,
        expanded: classes.expanded
      }}
    >
      <AccordionSummary
        classes={{
          expandIcon: classes.expandIcon,
          root: classes.accordionSummary,
          expanded: classes.expanded,
          content: classes.content
        }}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Header severity={severity} countRows={countRows} />
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.accordionDetails }}>
        <Rows severity={severity} rowsData={rowsData} />
      </AccordionDetails>
    </Accordion>
  );
};

SeverityGroup.propTypes = {
  severity: PropTypes.string,
  rowsData: PropTypes.array
};

export default SeverityGroup;
